var modules_ff399ec7 = {"container":"ControlGroup_module_container__0547b8e6"};
import "../../../assets/esm/components/ControlGroup/src/ControlGroup~-9zMxKX8.css";

export { modules_ff399ec7 as default };
//# sourceMappingURL=ControlGroup.module.less.js.map
